import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import useGetUserInfo from './hooks/useGetUserInfo'
import Header from 'components/headers/bulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import UserInfo from 'modules/financialHistory/userInfo'
import CustomTabs from 'modules/financialHistory/tabs'

export default function FinancialHistory() {
    const { moneyPool, poolship } = useParams()
    const { userInfo, isLoadingUserInfo } = useGetUserInfo()
    useEffect(() => {
        posthog.capture('member_detail_viewed', {
            fund_id: moneyPool,
            poolship_id: poolship,
        })
    }, [moneyPool, poolship])
    return (
        <div className=" bg-white min-h-screen">
            <Header title="سابقه مالی عضو" />
            {isLoadingUserInfo ? (
                <DotsLoading />
            ) : (
                userInfo && <UserInfo data={userInfo} />
            )}
            <CustomTabs />
        </div>
    )
}
